import { Box, Typography } from '@mui/material'
import noDataFoundImage from '../../images/noDataFound.svg'
import { ReactComponent as EmptyBoxIcon } from '../../images/emptyBox.svg'
import UseTranslation from '../../hooks/UseTranslation'

const NoDataFound = ({
  customTitle,
  customSecondTitle,
  customImg,
  withoutImg,
  withoutIcon,
  customShow = true,
  customStyle,
  store,
}) => {
  const { t } = UseTranslation()
  const isLoading = Boolean(store?.loading === true);
  const isFetching = store?.loading && typeof store?.loading === 'object' ? store?.loading.fetch : false;
  const isMutating = store?.loading && typeof store?.loading === 'object' ? store?.loading.mutate : false;

  return (
    <Box sx={[styles.root, customStyle]}>
      {!isLoading && !isFetching && !isMutating && !store?.pageNumber && !store?.data?.length &&
      customShow && (
        <>
          {!withoutImg &&
            <img src={customImg ?? noDataFoundImage} alt="No Data Found" />}

          <Typography sx={styles.text}>
            {!withoutIcon &&
              <EmptyBoxIcon />}
            {customTitle ?? t?.['No Added Data to be Shown']}
          </Typography>
          <Typography sx={styles.text2}>
            {customSecondTitle ?? ''}
          </Typography>
        </>
      )}
    </Box>
  )
}

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& svg': {
      filter: 'invert(62%) sepia(61%) saturate(401%) hue-rotate(96deg) brightness(97%) contrast(95%)',
    },

    '& img': {
      width: { xs: '200px', sm: '500px' },
      height: { xs: '220px', sm: '460px' },
    },

  },
  text: {
    display: 'flex',
    alignItems: 'center',
    gap: '13px',
    color: '#44CC84',
    fontsize: '16px',
    m: '15px',
  },
  text2: {
    fontsize: '16px',
    fontWeight: 700,
    color: '#8D8F99',
  },

}

export default NoDataFound
